import { cn } from '@lib/util/cn';
import SearchAutocomplete from '@modules/search/components/search-autocomplete';

const MobileSearchBar = ({
  className,
  onNavigate,
}: {
  className?: string;
  onNavigate?: () => void;
}) => {
  return (
    <div
      className={cn(
        'desktop:hidden p-4 bg-white border-b border-neutral-200',
        className,
      )}
    >
      <SearchAutocomplete variant="mobile" onNavigate={onNavigate} />
    </div>
  );
};

export default MobileSearchBar;
